var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-default-overlay is-active" },
    [
      !_vm.loading
        ? [
            _c(
              "button",
              {
                staticClass: "close-button c-overlay-close-button",
                attrs: { "aria-label": "Close alert", type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeReveal.apply(null, arguments)
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-default-overlay-wrapper" }, [
              _c("h2", { staticClass: "c-heading-large" }, [
                _vm._v(_vm._s(_vm.translate("frontend.js.reviews.heading")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-relative" },
                [
                  _c(
                    "h2",
                    { staticClass: "c-heading-medium u-margin-bottom-small" },
                    [_vm._v("Onze recensies")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.reviews, function(review) {
                    return _c("div", { staticClass: "c-review-wrapper" }, [
                      _c("figure", { staticClass: "c-figure-avatar" }, [
                        _c("img", {
                          staticClass: "c-figure-image",
                          attrs: {
                            alt: "",
                            src: review.single_file
                              ? _vm.changeImageSize(
                                  review.single_file.media_path,
                                  80,
                                  80
                                )
                              : "/assets/images/frontend/review_default.png"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-review" }, [
                        _c(
                          "h3",
                          { staticClass: "c-heading-small u-no-margin-bottom" },
                          [_vm._v(_vm._s(review.name))]
                        ),
                        _vm._v(" "),
                        review.storage_box
                          ? _c("span", { staticClass: "c-review-sub" }, [
                              _vm._v(_vm._s(review.storage_box.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "c-review-text" }, [
                          _vm._v("“" + _vm._s(review.description) + "”")
                        ])
                      ])
                    ])
                  })
                ],
                2
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cbf7757", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbf7757","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/global/reviews-reveal.vue
// module id = 244
// module chunks = 3